import { render } from "./RecordingPage.vue?vue&type=template&id=4557b702&lang=html"
import script from "./RecordingPage.vue?vue&type=script&lang=js&defer=true"
export * from "./RecordingPage.vue?vue&type=script&lang=js&defer=true"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__